import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-flexbox-grid";

export default class DojoCol extends Component {
  render() {
    const { style, children, ...restProps } = this.props;

    const colStyles = {
      paddingTop: "0",
      paddingRight: "0",
      paddingBottom: "0",
      paddingLeft: "0",
      ...style,
    };

    return (
      <Col style={colStyles} {...restProps}>
        {children}
      </Col>
    );
  }
}

DojoCol.propTypes = {
  style: PropTypes.object,
};
